import React from 'react';

export const TemplateEditorSkeleton: React.FC = () => {
  return (
    <div>
      <style>{`
        @keyframes shimmer {
          0%   { background-position: -800px 0; }
          100% { background-position:  800px 0; }
        }

        .sk {
          background: linear-gradient(90deg, #e8e3fb 25%, #d5cef5 50%, #e8e3fb 75%);
          background-size: 800px 100%;
          animation: shimmer 1.5s infinite linear;
          border-radius: 6px;
          display: block;
        }

        .sk-template-card {
          border: 1px solid #ddd;
          border-radius: 6px;
          overflow: hidden;
          cursor-events: none;
        }

        .sk-template-thumbnail {
          width: 100%;
          height: 80px;
          background: linear-gradient(90deg, #e8e3fb 25%, #d5cef5 50%, #e8e3fb 75%);
          background-size: 800px 100%;
          animation: shimmer 1.5s infinite linear;
        }

        .sk-template-title {
          padding: 8px;
          height: 28px;
          display: flex;
          align-items: center;
          background: #f9fafb;
        }

        .sk-template-text {
          width: 70%;
          height: 12px;
        }

        .sk-template-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 8px;
        }

        @media (min-width: 640px) {
          .sk-template-thumbnail {
            height: 90px;
          }

          .sk-template-title {
            padding: 10px;
            height: 32px;
          }

          .sk-template-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 10px;
          }
        }

        @media (min-width: 1024px) {
          .sk-template-thumbnail {
            height: 100px;
          }

          .sk-template-title {
            padding: 12px;
            height: 36px;
          }

          .sk-template-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 12px;
          }
        }

        @media (min-width: 1280px) {
          .sk-template-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
      `}</style>

      <div className="sk-template-grid">
        {Array.from({ length: 4 }).map((_, index) => (
          <div key={index} className="sk-template-card">
            <div className="sk-template-thumbnail" />
            <div className="sk-template-title">
              <div className="sk sk-template-text" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
